export default __webpack_public_path__ + "static/media/file.3c97f1a1.png";